import EFPicture from '@elem/compCommon/EFPicture';
import Close from '../A/icons/Close';
import Light from '../A/icons/Light';
import TV from '../A/icons/TV';
import Washer from '../A/icons/Washer';
import Oven from '../A/icons/Oven';
import Refrigerator from '../A/icons/Refrigerator';
import Microwave from '../A/icons/Microwave';
import CoffeeMaker from '../A/icons/CoffeeMaker';
import AC from '../A/icons/AC';
import Car from '../A/icons/Car';
import Cooker from '../A/icons/Cooker';
import DishWasher from '../A/icons/DishWasher';
import css from './DetailModal.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function DetailModal({ selection, callback }: any) {
    const { useLang, useRouter, useState, useEffect, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('dpu_calculator');
    const { id, title, subtitle, img } = selection;

    const appsAll = [
        {
            icon: <Light />,
            text: t('step2_B_app_light'),
        },
        {
            icon: <TV />,
            text: t('step2_B_app_tv'),
        },
        {
            icon: <Washer />,
            text: t('step2_B_app_washing_machine'),
        },
        {
            icon: <Microwave />,
            text: t('step2_B_app_microwave'),
        },
        {
            icon: <Refrigerator />,
            text: t('step2_B_app_refriferator'),
        },
        {
            icon: <AC />,
            text: t('step2_B_app_ac'),
        },
        {
            icon: <Oven />,
            text: t('step2_B_app_oven'),
        },
        {
            icon: <DishWasher />,
            text: t('step2_B_app_dish_washer'),
        },
        {
            icon: <Cooker />,
            text: t('step2_B_app_cooker'),
        },
        {
            icon: <Car />,
            text: t('step2_B_app_car'),
        },
        {
            icon: <CoffeeMaker />,
            text: t('step2_B_app_coffee_maker'),
        },
    ];

    const apps = id === 'basic' ? appsAll.slice(0, 6) : id === 'advanced' ? appsAll.slice(0, 9) : appsAll;

    return (
        <div className={`detail-modal ${css['detail-modal']}`}>
            <div className="modal-content">
                <div className="modal-header">
                    <span className="header-title">{title}</span>
                    <span className="close" onClick={callback}>
                        <Close />
                    </span>
                </div>
                <div className="modal-body">
                    <div className="img-box">
                        <EFPicture src={img} alt={title} />
                    </div>
                    <div className="modal-info">
                        <div className="subtitle">{subtitle}</div>
                        <ul className="apps">
                            {apps?.map((app: any, k: number) => (
                                <li className="app" key={k}>
                                    {app.icon}
                                    <div className="app-text">{app.text}</div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
            <style jsx global>
                {`
                    .announcement-bar {
                        z-index: 100;
                    }
                    .ecoflow-frame-header {
                        z-index: 150 !important;
                    }
                    .festival-float {
                        z-index: 180;
                    }
                `}
            </style>
        </div>
    );
}
